const CollegeLocations = {
    'new-england': 'New England (ME, RI, VT, CT, NH, MA)',
    'southern': 'Southern (VA, WV, KY, DE, MD, NC, SC, TN, AR, LA, FL, GA, AL, MS)',
    'mid-west': 'Mid-West (MI, ND, SD, IA, MN, KS, NE, OH, IN, IL, WI, MO)',
    'south-west': 'South-West (TX, AZ, NM, OK)',
    'rocky-mountains': 'Rocky Mountains (MT, ID, CO, UT, WY, NV)'
};

export default CollegeLocations;
